// all crypto helpers, has nothing to do with the Demo UI
import CryptoJS from 'crypto-js';

class AesUtil {
  keySize: number;
  iterationCount: number;

  constructor(ks: number, i: number) {
    this.keySize = ks / 32;
    this.iterationCount = i;
  }

  generateKey = (salt: string, passPhrase: string) => {
    var key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
      keySize: this.keySize,
      iterations: this.iterationCount,
    });
    return key;
  };

  encrypt = (
    salt: string,
    iv: string,
    passPhrase: string,
    plainText: string
  ) => {
    var key = this.generateKey(salt, passPhrase);
    // IMPORTANT: My installed java requires 16byte hex
    var paddediv = iv.padStart(32, '0');
    var encrypted = CryptoJS.AES.encrypt(plainText, key, {
      iv: CryptoJS.enc.Hex.parse(paddediv)
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  };

  decrypt = (
    salt: string,
    iv: string,
    passPhrase: string,
    cipherText: string
  ) => {
    var key = this.generateKey(salt, passPhrase);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(cipherText),
    });
    // IMPORTANT: My installed java requires 16byte hex
    var paddediv = iv.padStart(32, '0');
    var decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      iv: CryptoJS.enc.Hex.parse(paddediv)
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  padValue = (str: number) => {
    const hexLen = 16;
    return str.toString(hexLen).padStart(hexLen, '0'); 
  }

  cryptoRandom = () => {
    const crypto = window.crypto;
    const array = new Uint32Array(1);
    const randomArrayValue = crypto.getRandomValues(array) || [0];
    return 100000000 / randomArrayValue[0];
  }

  generateSalt = () => {
    const min = 65535;
    const max = Number.MAX_SAFE_INTEGER;
    const crypto = this.cryptoRandom();
    return this.padValue(Math.round(crypto * (max - min)) + min);
  };

  generateIV = () => {
    const cd = new Date();
    const crypto = this.cryptoRandom();
    const off = Math.round(crypto * 6000 - 3000);
    return this.padValue(cd.getTime() + off);
  };
}

export default AesUtil;
